import { createGlobalStyle } from "styled-components";
import styled from "styled-components";
import { TypoHeading1, TypoSubtitleStyles } from "@/styles/Styled.Typography";
import { fluid } from "@/styles/utils/fluid";
import CaveatWoff2 from "@/assets/fonts/Caveat-Regular.woff2";
import CaveatWoff from "@/assets/fonts/Caveat-Regular.woff";

export const GlobalStyle = createGlobalStyle`
@font-face {
  font-family: 'Caveat';
  font-style: normal;
  font-weight: 400;
  src: url(${CaveatWoff2}) format('woff2'),
       url(${CaveatWoff}) format('woff');
  font-display: swap;
}`;

export const CaveatWrapper = styled.div`
  position: relative;
  display: inline-block;
  margin-left: ${({ theme }) => `
    calc(${fluid({
      minSize: theme.spacing.pageSubtitle.xs,
      maxSize: theme.spacing.pageSubtitle.xl,
      minVW: theme.breakpointValues.xs, // 900
      maxVW: theme.breakpointValues.xl, // 1200 or 1800?
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })} / 2)
  `};
  color: ${({ theme }) => theme.colors.onyx};
  text-decoration: line-through;
  text-decoration-color: ${({ theme }) => theme.colors.imperialRed};
`;

export const TypoScribble = styled.div`
  ${TypoSubtitleStyles};
  font-family: ${({ theme }) => theme.fontFace.caveat};
`;

export const CaveatSubtitle = styled(TypoScribble)`
  margin: 0;
  padding: 0;
  position: absolute;
  bottom: -90%;
  left: 0;
  right: 0;
  text-transform: none;
`;

export const ImgWrapperStyle = styled.div`
  border-top: 2px solid ${({ theme }) => theme.colors.onyx};
  border-bottom: 2px solid ${({ theme }) => theme.colors.onyx};
  min-height: 250px;
  img {
    width: 100%;
    height: auto;
    display: block;
  }
`;

export const ImgWrapper = styled.div`
  position: relative;
  z-index: 1;
  overflow: hidden;
  width: 100%;
  height: auto;
`;

export const GridHomeIntro = styled.div`
  display: grid;
  gap: 0;
  min-height: 0;
  min-width: 0; /* NEW; needed for Firefox */
  /* &:last-of-type {
    border-bottom: none;
  } */
  grid-auto-rows: min-content;
  /* xs only */
  @media ${({ theme }) => theme.breakpoints.xs} {
    grid-template-columns: 1fr;
    gap: ${({ theme }) => `
      ${fluid({
        minSize: theme.spacing.section.xs,
        maxSize: theme.spacing.section.md,
        minVW: theme.breakpointValues.xs, // 900
        maxVW: theme.breakpointValues.md, // 1200 or 1800?
        baseFontMin: theme.baseFont.xs,
        baseFontMax: theme.baseFont.md,
      })}
      0
    `};
  }
  /* sm and up */
  @media ${({ theme }) => theme.breakpoints.sm} {
    grid-template-columns: 1fr;
    gap: ${({ theme }) => `
      ${fluid({
        minSize: theme.spacing.section.xs,
        maxSize: theme.spacing.section.md,
        minVW: theme.breakpointValues.xs, // 900
        maxVW: theme.breakpointValues.md, // 1200 or 1800?
        baseFontMin: theme.baseFont.xs,
        baseFontMax: theme.baseFont.md,
      })}
      0
    `};
  }
  /* sm to md */
  @media ${({ theme }) => theme.breakpoints.md} {
    grid-template-columns: [outer-start] 1fr [center-start] 8fr [center-end] 1fr [outer-end];
    gap: ${({ theme }) => `
      ${fluid({
        minSize: theme.spacing.section.xs,
        maxSize: theme.spacing.section.md,
        minVW: theme.breakpointValues.xs, // 900
        maxVW: theme.breakpointValues.md, // 1200 or 1800?
        baseFontMin: theme.baseFont.xs,
        baseFontMax: theme.baseFont.md,
      })}
      0
    `};
  }
  /* md and up */
  @media ${({ theme }) => theme.breakpoints.lg} {
    grid-template-columns: repeat(auto-fit, minmax(380px, 1fr));
  }
  /* lg to xl */
  @media ${({ theme }) => theme.breakpoints.xl} {
    grid-template-columns: repeat(auto-fit, minmax(480px, 1fr));
  }
  gap: ${({ theme }) => `
    0
    ${fluid({
      minSize: theme.spacing.section.md,
      maxSize: theme.spacing.section.xl,
      minVW: theme.breakpointValues.md, // 900
      maxVW: theme.breakpointValues.xl, // 1200 or 1800?
      baseFontMin: theme.baseFont.md,
      baseFontMax: theme.baseFont.xl,
    })}
  `};
  padding: ${({ theme }) => `
    0
    0
    ${fluid({
      minSize: theme.spacing.section.xs,
      maxSize: theme.spacing.section.xl,
      minVW: theme.breakpointValues.xs, // 900
      maxVW: theme.breakpointValues.xl, // 1200 or 1800?
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })}
    0
  `};
`;

export const GridItemHomeIntro = styled.div`
  /* grid-template-rows: min-content 1fr; */
  grid-column: auto;
  /* sm to md */
  @media ${({ theme }) => theme.breakpoints.md} {
    grid-column: center-start / center-end;
  }
`;

export const HomeAboutHeading = styled(TypoHeading1)`
  position: absolute;
  z-index: 2;
  text-align: right;
  right: ${({ theme }) =>
    fluid({
      minSize: theme.spacing.vertical.xs,
      maxSize: theme.spacing.vertical.xl,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.xl,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })};
  &::selection {
    color: ${(props) =>
      props.$sectionAboutH2 ? props.theme.colors.imperialRed : ""};
  }
  /* xs only */
  @media ${({ theme }) => theme.breakpoints.xs} {
    bottom: ${({ theme }) => theme.spacing.vertical.xs}rem;
  }
  /* sm and up */
  @media ${({ theme }) => theme.breakpoints.sm} {
    bottom: ${({ theme }) =>
      fluid({
        minSize: theme.spacing.vertical.xs,
        maxSize: theme.spacing.vertical.sm,
        minVW: theme.breakpointValues.xs, // 900
        maxVW: theme.breakpointValues.sm, // 1200 or 1800?
        baseFontMin: theme.baseFont.xs,
        baseFontMax: theme.baseFont.sm,
      })};
  }
  /* sm to md */
  @media ${({ theme }) => theme.breakpoints.md} {
    bottom: ${({ theme }) =>
      fluid({
        minSize: theme.spacing.vertical.sm,
        maxSize: theme.spacing.vertical.md,
        minVW: theme.breakpointValues.sm, // 900
        maxVW: theme.breakpointValues.md, // 1200 or 1800?
        baseFontMin: theme.baseFont.sm,
        baseFontMax: theme.baseFont.md,
      })};
  }
  /* md and up */
  @media ${({ theme }) => theme.breakpoints.lg} {
    position: relative;
    padding-bottom: ${({ theme }) =>
      fluid({
        minSize: theme.spacing.vertical.md,
        maxSize: theme.spacing.vertical.lg,
        minVW: theme.breakpointValues.md, // 900
        maxVW: theme.breakpointValues.lg, // 1200 or 1800?
        baseFontMin: theme.baseFont.md,
        baseFontMax: theme.baseFont.lg,
      })};
  }
  /* lg to xl */
  @media ${({ theme }) => theme.breakpoints.xl} {
    top: 50%;
    transform: translateY(-50%);
  }
`;

export const GridHomeAbout = styled.div`
  display: grid;
  gap: 0;
  min-height: 0;
  min-width: 0; /* NEW; needed for Firefox */
  /* &:last-of-type {
    border-bottom: none;
  } */
  /* xs only */
  @media ${({ theme }) => theme.breakpoints.xs} {
    grid-template-columns: 1fr;
    gap: ${({ theme }) => `
      ${fluid({
        minSize: theme.spacing.section.xs,
        maxSize: theme.spacing.section.md,
        minVW: theme.breakpointValues.xs, // 900
        maxVW: theme.breakpointValues.md, // 1200 or 1800?
        baseFontMin: theme.baseFont.xs,
        baseFontMax: theme.baseFont.md,
      })}
      0
    `};
  }
  /* sm and up */
  @media ${({ theme }) => theme.breakpoints.sm} {
    grid-template-columns: 1fr;
    grid-auto-rows: min-content;
    gap: ${({ theme }) => `
      ${fluid({
        minSize: theme.spacing.section.xs,
        maxSize: theme.spacing.section.md,
        minVW: theme.breakpointValues.xs, // 900
        maxVW: theme.breakpointValues.md, // 1200 or 1800?
        baseFontMin: theme.baseFont.xs,
        baseFontMax: theme.baseFont.md,
      })}
      0
    `};
  }
  /* sm to md */
  @media ${({ theme }) => theme.breakpoints.md} {
    grid-template-columns: [outer-start] 1fr [center-start] 8fr [center-end] 1fr [outer-end];
    gap: ${({ theme }) => `
      ${fluid({
        minSize: theme.spacing.section.xs,
        maxSize: theme.spacing.section.md,
        minVW: theme.breakpointValues.xs, // 900
        maxVW: theme.breakpointValues.md, // 1200 or 1800?
        baseFontMin: theme.baseFont.xs,
        baseFontMax: theme.baseFont.md,
      })}
      0
    `};
  }
  /* md and up */
  @media ${({ theme }) => theme.breakpoints.lg} {
    grid-template-columns: 1fr 1fr;
    grid-auto-rows: min-content;
  }
  /* lg to xl */
  @media ${({ theme }) => theme.breakpoints.xl} {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr;
  }
  gap: ${({ theme }) => `
      0
      ${fluid({
        minSize: theme.spacing.section.md,
        maxSize: theme.spacing.section.xl,
        minVW: theme.breakpointValues.md, // 900
        maxVW: theme.breakpointValues.xl, // 1200 or 1800?
        baseFontMin: theme.baseFont.md,
        baseFontMax: theme.baseFont.xl,
      })}
    `};
  padding: ${({ theme }) => `
      ${fluid({
        minSize: theme.spacing.section.xs,
        maxSize: theme.spacing.section.xl,
        minVW: theme.breakpointValues.xs, // 900
        maxVW: theme.breakpointValues.xl, // 1200 or 1800?
        baseFontMin: theme.baseFont.xs,
        baseFontMax: theme.baseFont.xl,
      })}
      0
    `};
`;

export const GridItemHomeAbout = styled.div`
  grid-column: 1 / 2;
  /* sm to md */
  @media ${({ theme }) => theme.breakpoints.md} {
    grid-column: center-start / center-end;
  }
  /* md and up */
  @media ${({ theme }) => theme.breakpoints.lg} {
    grid-column: auto;
  }
  /* lg to xl */
  @media ${({ theme }) => theme.breakpoints.xl} {
    grid-column: auto;
  }
`;

export const GridHomeHighlights = styled.div`
  display: grid;
  gap: 0;
  min-height: 0;
  min-width: 0; /* NEW; needed for Firefox */
  /* &:last-of-type {
    border-bottom: none;
  } */
  ul {
    margin: ${({ theme }) => `
      0
      0
      ${fluid({
        minSize: theme.spacing.section.xs,
        maxSize: theme.spacing.section.xl,
        minVW: theme.breakpointValues.xs, // 900
        maxVW: theme.breakpointValues.xl, // 1200 or 1800?
        baseFontMin: theme.baseFont.xs,
        baseFontMax: theme.baseFont.xl,
      })}
    `};
  }
  grid-template-columns: 1fr;
  /* sm to md */
  @media ${({ theme }) => theme.breakpoints.md} {
    grid-template-columns: [outer-start] 1fr [center-start] 8fr [center-end] 1fr [outer-end];
  }
`;
